<template>
  <div class="download">
    <div class="download__btn" @click="downloadProject">匯出專案</div>
    <div class="download__btn btn--example" @click="downloadExample">
      匯出範例
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getAppUrl } from "../../utils/domain";

export default {
  name: "Download",
  computed: {
    ...mapGetters(["project", "env"]),
  },
  methods: {
    downloadProject() {
      window.location.href = getAppUrl(
        `/excel/download/${this.project}/?env=${this.env}`,
      );
    },
    downloadExample() {
      window.location.href = getAppUrl("/excel/sample");
    },
  },
};
</script>
<style lang="scss" scoped>
.download {
  display: flex;
  margin: 0.75rem 0;
  @media screen and (min-width: 768px) {
    margin: 1rem 0;
  }
  .download__btn {
    background-color: #21ba45;
    color: #fff;
    box-shadow: 0 0 0 0 rgba(34, 36, 38, 0.15) inset;
    padding: 0.5rem 1.5rem;
    border-radius: 0.3rem;
    cursor: pointer;
    &:hover {
      background-color: #16ab39;
    }
  }
  .btn--example {
    margin-left: 1rem;
    background-color: #a5673f;
    &:hover {
      background-color: #975b33;
    }
  }
}
</style>
